import { render, staticRenderFns } from "./anularInclusion.vue?vue&type=template&id=b8d494a6&"
import script from "./anularInclusion.vue?vue&type=script&lang=js&"
export * from "./anularInclusion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports